import { create } from 'zustand';

interface Question {
  id: string;
  text: string;
  timeLimit: number;
}

interface QuestionsState {
  questions: Question[];
  setQuestions: (questions: Question[]) => void;
}

export const useQuestions = create<QuestionsState>((set) => ({
  questions: [], // Start empty; load from API in flow
  setQuestions: (questions) => set({ questions }),
}));